import BasicModel from '../basic/BasicModel'
export default {
  findPosterList(vm, params , listener) {
    let action = 'distributor/findPosterList.action'
    BasicModel.get(vm, action, params, listener)
  },
  deletePoster(vm, params, listener) {
    let action = 'distributor/deletePoster.action'
    BasicModel.post(vm, action, params, listener)
  },
  savePoster(vm, params, listener) {
    let action = 'distributor/savePoster.action'
    BasicModel.post(vm, action, params, listener)
  }
}
